import { AuthActionType, LoginAction, LogoutAction } from './auth.types';

export const login = (token: string | null, roles: string[]): LoginAction => {
  token && localStorage.setItem('userToken', token);

  return {
    type: AuthActionType.Login,
    payload: {
      isAdmin: roles.includes('ROLE_ADMIN'),
      isSuperFederal: roles.includes('ROLE_SUPER_FEDERAL'),
      isFederal: roles.includes('ROLE_FEDERAL'),
      isRepresentative: roles.includes('ROLE_REPRESENTATIVE'),
      isExpert:
        roles.includes('ROLE_EXPERT_POVS') || roles.includes('ROLE_NMS_MEMBER') ? false : roles.includes('ROLE_EXPERT'),
      isPovs: roles.includes('ROLE_EXPERT_POVS') || roles.includes('ROLE_POVS'),
      isNms: roles.includes('ROLE_NMS_MEMBER'),
      token: token,
    },
  };
};

export const logout = (): LogoutAction => {
  localStorage.removeItem('userToken');

  return {
    type: AuthActionType.Logout,
  };
};
